import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { resolveFormattingLocale } from '@wilson/localization';
import { numberFormatter } from '@wilson/utils';

@Pipe({
  name: 'numberFormatter',
  // Impure so the output follows language changes, including the switch from
  // the fallback locale once the language is set during bootstrap.
  // The result is memoized, so unchanged inputs skip re-formatting.
  pure: false,
})
export class NumberFormatterPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  private lastValue?: number;
  private lastOptions?: Intl.NumberFormatOptions;
  private lastLocale?: string;
  private lastResult = '';

  transform(value: number, options?: Intl.NumberFormatOptions): string {
    const locale = resolveFormattingLocale(
      this.translateService.getCurrentLang(),
    );

    if (
      locale === this.lastLocale &&
      Object.is(value, this.lastValue) &&
      options === this.lastOptions
    ) {
      return this.lastResult;
    }

    this.lastValue = value;
    this.lastOptions = options;
    this.lastLocale = locale;
    this.lastResult = this.formatValue(value, locale, options);
    return this.lastResult;
  }

  /** Formats a value; subclasses override this to change the number style. */
  protected formatValue(
    value: number,
    locale: string,
    options?: Intl.NumberFormatOptions,
  ): string {
    return numberFormatter(locale, options)(value);
  }
}
